import { useEffect, useState } from 'react'
import { useRouteContext } from '@tanstack/react-router'
import { MOBILE_VIEWPORT_QUERY } from '~/lib/mobile'

/**
 * Returns whether the current client is "mobile" — true if either:
 *   - The server-detected User-Agent was mobile (carried through root route context), or
 *   - The live viewport is narrower than the `md` breakpoint (768px).
 *
 * The server-seeded value is used for the first render to avoid a desktop→mobile flash
 * during hydration. After mount, the client viewport takes over, so rotation, split-screen,
 * or desktop browsers resized small all correctly flip to mobile layout.
 */
export function useIsMobile(): boolean {
  const { isMobile: serverIsMobile } = useRouteContext({ from: '__root__' })
  const [isMobile, setIsMobile] = useState<boolean>(serverIsMobile)

  useEffect(() => {
    const mql = window.matchMedia(MOBILE_VIEWPORT_QUERY)
    const update = () => setIsMobile(mql.matches)
    update()
    mql.addEventListener('change', update)
    return () => mql.removeEventListener('change', update)
  }, [])

  return isMobile
}
